import PropTypes from "prop-types"
import React, { useState } from "react"
import { useQueryClient } from "react-query"
import ReversePaymentConfirmationModal from "src/main/Billing/Payments/ReversePaymentConfirmationModal"
import ReversePaymentButton from "src/main/Billing/ReversePaymentButton"
import { invalidateBillingSurfaces } from "src/main/Billing/invalidateBillingSurfaces"

import Badge from "src/components/Badge"
import { statusToken } from "src/components/Badge/status_tokens"
import SideSheet from "src/components/SideSheet"

import { PAYMENT_ICON, formatDay } from "./helpers"

const PaymentHeader = ({ payment }) => {
  const queryClient = useQueryClient()
  const [isConfirmingReversal, setIsConfirmingReversal] = useState(false)

  const title = payment.displaySequentialId || "Payment"
  const details = [formatDay(payment.paidOn), payment.contactName]

  const reloadPayment = () => queryClient.invalidateQueries(["paymentTxn"])

  const reloadAfterReversal = () => invalidateBillingSurfaces(queryClient)

  const reverseControl = (
    <ReversePaymentButton
      disabledMessage={payment.reversePaymentDisabledMessage}
      onClick={() => setIsConfirmingReversal(true)}
    />
  )

  return (
    <header className="flex flex-wrap items-start justify-between gap-4">
      <div className="flex items-start gap-4">
        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg border border-gray-300">
          <i
            className={`${PAYMENT_ICON} text-[32px] text-supplementary-green-600`}
            aria-hidden="true"
          />
        </div>
        <div>
          <div className="flex flex-wrap items-center gap-3">
            <h1 className="m-0 text-2xl font-bold text-gray-900">{title}</h1>
            <Badge
              text={payment.statusLabel}
              color={statusToken(payment.status)}
            />
          </div>
          <p className="m-0 mt-1 text-sm text-gray-700">
            {details.filter(Boolean).join(" · ")}
          </p>
        </div>
      </div>
      {payment.canReverse && (
        <SideSheet.HeaderActions>{reverseControl}</SideSheet.HeaderActions>
      )}
      <ReversePaymentConfirmationModal
        isOpen={isConfirmingReversal}
        onClose={() => setIsConfirmingReversal(false)}
        onReverseSuccess={() => {
          setIsConfirmingReversal(false)
          reloadAfterReversal()
        }}
        onReverseError={reloadPayment}
        paymentTxnId={payment.id}
        invoices={payment.invoices}
        examples={payment.reversalExamples}
      />
    </header>
  )
}

PaymentHeader.propTypes = {
  payment: PropTypes.shape({
    id: PropTypes.string.isRequired,
    displaySequentialId: PropTypes.string,
    status: PropTypes.string.isRequired,
    statusLabel: PropTypes.string.isRequired,
    paidOn: PropTypes.string.isRequired,
    contactName: PropTypes.string,
    reversePaymentDisabledMessage: PropTypes.string,
    canReverse: PropTypes.bool.isRequired,
    invoices: PropTypes.array.isRequired,
    reversalExamples: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
}

export default PaymentHeader
